import { useCallback } from 'react';
import YouTube from 'react-youtube';

import { Box } from '@mui/material';

import clsx from 'clsx';

import { EVENTS, useTrack } from '@arrived/analytics';
import { Offering } from '@arrived/models';

import { PropertyThumbnailProps, StyledPropertyThumbnail } from './PropertyThumbnail';

export interface PropertyVideoProps extends Omit<PropertyThumbnailProps, 'offering' | 'PropertyStatusFlagComponent'> {
  offering: Offering;
  video: string;
}

// Parameters for the YouTube embedded player, more information can be found
// https://developers.google.com/youtube/player_parameters
const playerOptions = { playerVars: { rel: 0 } };

/**
 * TODO: Replace this and PropertyThumbnail with better components that aren't styled as complexly. Purely using this
 *  as a stop-gap to get the feature out and then we can tackle making these components easier to use.
 */
export const PropertyVideo = ({
  className,
  offering,
  isForcedHeight,
  thumbnailHeight,
  thumbnailWidth,
  video,
  wrapperHeight,
  wrapperWidth,
}: PropertyVideoProps) => {
  const track = useTrack();

  const handleOnPlay = useCallback(() => {
    track(EVENTS.OFFERING_VIDEO_WATCHED, {
      offering_id: offering.id,
      property_name: offering.name,
    });
  }, [offering, track]);

  return (
    <StyledPropertyThumbnail
      $imageHeight={thumbnailHeight}
      $imageWidth={thumbnailWidth}
      $isForcedHeight={isForcedHeight}
      $wrapperHeight={wrapperHeight}
      $wrapperWidth={wrapperWidth}
      className={clsx('property-thumbnail-wrapper', className)}
    >
      <Box
        className="property-thumbnail-image-wrapper"
        position="relative"
        sx={{ '& .youtube-player': { aspectRatio: '373 / 224', height: 'auto', width: '100%' } }}
      >
        <YouTube videoId={video} iframeClassName="youtube-player" onPlay={handleOnPlay} opts={playerOptions} />
      </Box>
    </StyledPropertyThumbnail>
  );
};
